import { Component, OnInit } from '@angular/core';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';
import { GlobalService } from '../global.service';
import { HttpService } from '../http.service';

@Component({
  selector: 'app-employee-order-excel',
  templateUrl: './employee-order-excel.component.html',
  styleUrls: ['./employee-order-excel.component.scss']
})
export class EmployeeOrderExcelComponent implements OnInit {
  monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  month_list_for_last_12_months: any = [];
  customer_type_list: any = [{'name':'Ex-Employee', 'id': [2]}, {'name':'Employee', 'id': [3]}, {'name':'Both', 'id': [2,3]}];
  selected_month: any;
  selected_customer_type: any;
  document_file: any = null;
  is_document_available: boolean = true;
  is_data_available: boolean = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  title = null;
  constructor(private http: HttpService, private global: GlobalService) {
    this.title = this.global._active_display_name;
    let today = new Date();
    today.setDate(1);
    let data_dict = {
      'month_in_string': this.monthNames[today.getMonth()],
      'month_in_integer': today.getMonth(),
      'year': today.getFullYear()
    }
    this.month_list_for_last_12_months.push(data_dict);
    for (let i = 0; i <= 11; i++) {
      today.setMonth(today.getMonth() - 1);
      let data_dict = {
        'month_in_string': this.monthNames[today.getMonth()],
        'month_in_integer': today.getMonth(),
        'year': today.getFullYear()
      };
      this.month_list_for_last_12_months.push(data_dict);
    }
    console.log(this.month_list_for_last_12_months);
  }

  getClicked() {
    let data_dict = {
      'month': this.selected_month['month_in_integer'] + 1,
      'year': this.selected_month['year'],
      'customer_type_id': this.selected_customer_type,
    };
    console.log(data_dict);
    this.is_data_available = false;
    this.document_file = null;
    this.http.serveExcelForEmployeeOrder(data_dict).subscribe((data) => {
      console.log(data);
      this.document_file = data;
      if(data['show_alert'] == true){
        this.document_file = null;
        alert(data['alert'])
      }
      this.is_data_available = true;
    }, (error) => {
      this.is_data_available = true;
    });
  }

  downloadClicked() {
    const linkSource = 'data:application/xlsx;base64,' + this.document_file['excel'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  ngOnInit() {
  }

}
